import React, { useState } from "react";
import { ChevronRight } from "lucide-react";
import { Tooltip } from "@mui/material";
import Collection from "./Collection";

const SourceTypeGroup = ({
  sourceType,
  collections,
  setUrl,
  setMethod,
  setHeaders,
  setQueryParams,
  setEndPoint,
  setActiveTab,
  setCollectionId,
  setCurrentCollectionData,
  setEndpointFormOpen,
  setResponse5,
  setChainResult,
  selectedCollectionId,
  selectedEndpointId,
  setSelectedCollectionId,
  setSelectedEndpointId,
  setBaseUrl,
  loadEndpointData,
  startGenerationStatusPolling,
  setCollectionResults,
  setChainTest,
  setLoader,
  setSaveButton,
  setCurrentCollection,
}) => {
  const [isOpen, setIsOpen] = useState(true);

  const displayName = (sourceType || "UNKNOWN SOURCE").toUpperCase();
  const totalCollections = collections.length;
  const totalEndpoints = collections.reduce((sum, c) => sum + (c.endpoints?.length || 0), 0);
  const tooltipTitle = `${totalCollections} ${totalCollections === 1 ? "collection" : "collections"} · ${totalEndpoints} ${totalEndpoints === 1 ? "endpoint" : "endpoints"}`;

  return (
    <div className="mb-0">
      <button
        onClick={() => setIsOpen((p) => !p)}
        className="w-full flex items-center gap-2 px-3 py-2 hover:bg-gray-100 transition-colors duration-100 cursor-pointer text-left group"
      >
        <ChevronRight
          size={14}
          className="text-gray-500 flex-shrink-0 transition-transform duration-150"
          style={{ transform: isOpen ? "rotate(90deg)" : "none" }}
        />

        <span
          className="flex-1 text-[13px] font-bold text-gray-700 uppercase tracking-wide truncate"
          title={displayName}
        >
          {displayName}
        </span>

        <Tooltip title={tooltipTitle} arrow placement="right">
          <span className="flex-shrink-0 flex items-center gap-1 text-[11px] font-medium text-gray-400 cursor-default">
            <span>{totalCollections}c</span>
            <span className="text-gray-300">·</span>
            <span>{totalEndpoints}e</span>
          </span>
        </Tooltip>
      </button>

      {isOpen && (
        <div className="pb-1 px-1">
          {collections.map((collection, i) => (
            <Collection
              key={collection.id ?? i}
              collection={collection}
              nested={true}
              setUrl={setUrl}
              setMethod={setMethod}
              setHeaders={setHeaders}
              setQueryParams={setQueryParams}
              setSaveButton={setSaveButton}
              setCurrentCollection={setCurrentCollection}
              setEndPoint={setEndPoint}
              setActiveTab={setActiveTab}
              setCollectionId={setCollectionId}
              setCurrentCollectionData={setCurrentCollectionData}
              setEndpointFormOpen={setEndpointFormOpen}
              setResponse5={setResponse5}
              setChainResult={setChainResult}
              selectedCollectionId={selectedCollectionId}
              selectedEndpointId={selectedEndpointId}
              setSelectedCollectionId={setSelectedCollectionId}
              setSelectedEndpointId={setSelectedEndpointId}
              setBaseUrl={setBaseUrl}
              loadEndpointData={loadEndpointData}
              startGenerationStatusPolling={startGenerationStatusPolling}
              setCollectionResults={setCollectionResults}
              setChainTest={setChainTest}
              setLoader={setLoader}
            />
          ))}
        </div>
      )}

      <div className="mx-3 border-b border-gray-100 mt-1 mb-2" />
    </div>
  );
};

export default SourceTypeGroup;
